import { createAction } from 'redux-act';

export const fetchComponentCardFailed = createAction('Fetch ComponentCardFailed Failed');
export const setCtaCards = createAction<any>('Fetch ComponentCardFailed Failed');
